export default __webpack_public_path__ + "static/media/bg4.caf29890.png";